<template>
    <div id="sync-progress">
        <div v-if="syncing"
             class="loading-overlay"
             :class="{'error': !!error}">
            <div v-if="error">
                <h3 class="user-selectable">
                    {{ errorMessageTitle }}
                </h3>
                <h3 v-if="error.message"
                    class="user-selectable">
                    {{ error.message }}
                </h3>
                <h4>{{ l('SYNC.FAILED_CONTACT') }}</h4>
                <a class="btn btn-default mt-1"
                   @click.prevent="retry">
                    {{ l('TRY_AGAIN') }}
                </a>
            </div>
            <div v-else>
                <h3>
                    <!-- The 3 em elements after the text are animated. The whitespace (or lack thereof)
                    is important, hence the strange formatting here. -->
                    <span v-if="currentItem">
                        {{ currentItemVerb }} {{ currentItemName }}
                    </span>
                    <span v-else>
                        {{ l('SYNC.LOADING') }}
                    </span>&nbsp;<em>.</em>&nbsp;<em>.</em>&nbsp;<em>.</em>
                </h3>

                <div class="progress">
                    <div class="progress-bar progress-bar progress-bar-striped active"
                         :style="{'width': percentComplete+'%'}">
                        {{ completeItems }} / {{ totalItems }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { container } from '@/container';
import { mapState } from 'vuex';
import { toSnakeCase } from '@/functions/strings';

export default {
    computed: {
        ...mapState(
            'sync',
            [
                'syncing',
                'error',
                'totalItems',
                'completeItems',
                'percentComplete',
                'currentItem',
                'lastItem',
            ],
        ),

        errorMessageTitle() {
            if (!this.error) {
                return null;
            }

            if (this.error.failedKey) {
                return container.langService.getText(
                    'SYNC.FAILED_KEY',
                    {
                        what: container.langService.getText('SYNC.' + toSnakeCase(this.error.failedKey).toUpperCase()),
                    },
                );
            }

            return container.langService.getText('SYNC.FAILED_GENERIC');
        },

        currentItemName() {
            if (!this.currentItem) {
                return null;
            }

            return container.langService.getText('SYNC.' + toSnakeCase(this.currentItem.name).toUpperCase());
        },

        currentItemVerb() {
            if (!this.currentItem) {
                return null;
            }

            return container.langService.getText('SYNC.' + this.currentItem.verb);
        },
    },

    methods: {
        retry() {
            window.location.reload();
        },
    },
};
</script>
